const _$id = (id) => document.getElementById(id), _addEventListener = ($e, eventName, handler) => {
    $e.addEventListener(eventName, handler);
}, _$ = (elementTree) => {
    if (elementTree instanceof HTMLElement ||
        elementTree instanceof Text) {
        return elementTree;
    }
    if (typeof elementTree === 'string') {
        return document.createTextNode(elementTree);
    }
    if (typeof elementTree === 'number') {
        const numStr = elementTree.toString();
        return document.createTextNode(numStr);
    }
    const $children = _$children(elementTree), tagName = elementTree[0], attrs = elementTree[1], $e = document.createElement(tagName);
    if (typeof attrs === 'object') {
        for (const attrName in attrs) {
            const attrValue = attrs[attrName];
            $e.setAttribute(attrName, attrValue);
        }
    }
    if ($children) {
        $e.append(...$children);
    }
    return $e;
}, _$children = (elementTree) => {
    const len = elementTree.length;
    if (len < 3) {
        return null;
    }
    const $children = [];
    for (let i = 2; i < len; ++i) {
        const subtree = elementTree[i], $child = _$(subtree);
        $children.push($child);
    }
    return $children;
};
export { _$id, _addEventListener, _$, };
